const translations: Record<string, string> = {
  "ak_misc_select": "— оберіть —",
  "ak_misc_empty": "Порожньо",
};

export default translations;
